import { render, staticRenderFns } from "./GFontSelectBox.vue?vue&type=template&id=066e818e&"
import script from "./GFontSelectBox.vue?vue&type=script&lang=ts&"
export * from "./GFontSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./GFontSelectBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports